<template>
    <v-app color="grey lighten-5">
        <v-card>
            <v-card-title>Webhook List
            <v-divider
                            class="mx-4"
                            inset
                            vertical
                        ></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                            outlined
                        ></v-text-field>
                        <v-divider
                            class="mx-4"
                            inset
                            vertical
                        ></v-divider>
                <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                color="teal accent-4"
                                dark
                                class="mb-2"
                                v-bind="attrs"
                                v-on="on"
                                >Add Webhook</v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">Add Webhook</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-text-field v-model="newItem.id" outlined type="number" disabled label="Redmine Project ID"></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-autocomplete
                                                    v-model="newItem"
                                                    :items="projectList"
                                                    :loading="isLoading"
                                                    item-text="name"
                                                    item-value="id"
                                                    color="black"
                                                    hide-no-data
                                                    hide-selected
                                                    return-object
                                                    outlined
                                                    label="Redmine Project Name"></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="add">Add</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
            </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="10"
            :loading="tableLoading"
            loading-text="Loading... Please wait"
            :search="search"
            :calculate-widths="true">
                <template v-slot:item.actions="{ item }">
                    <v-icon
                        small
                        @click="deleteItem(item)"
                    >
                        mdi-delete
                    </v-icon>
                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reset</v-btn>
                </template>
        </v-data-table>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            >
            {{ snackbarText }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="teal"
                    text
                    v-bind="attrs"
                    @click="closeSnackbar"
                >
                    OK
                </v-btn>
            </template>
        </v-snackbar>
    </v-app>
</template>

<script>

export default {
    data () {
        return {
            search: '',
            dialog: false,
            nameLimit: 60,
            headers: [
                {
                    text: "Redmine Project ID",
                    sortable: true,
                    align: "start",
                    value: "redmine_project_id",
                    width: "10%"
                },
                {
                    text: "Redmine Project Name",
                    sortable: true,
                    align: "start",
                    value: "redmine_project_name",
                },
                { text: "Api Key", value: "api_key" },
                { text: 'Actions', value: 'actions', sortable: false, width: "10%", align: "center" },
            ],
            page: 1,
            newItem: {
                id: 0,
                name: "",
            }
        }
    },
    methods: {
        initialize () {
            this.$store.dispatch('dashboard/getAllWebhooks')
        },
        close () {
            this.dialog = false
        },
        add() {
             if (this.newItem.id != 0 && this.newItem.name.length > 0) {
                const newWebhook = {
                    "redmine_project_id": parseInt(this.newItem.id),
                    "redmine_project_name": this.newItem.name,
                }
                this.$store.dispatch('dashboard/newWebhook', newWebhook)
            }
            this.dialog = false
        },
        closeSnackbar(){
            this.$store.commit('dashboard/closeSnackbar')
        },
        deleteItem(item){
            this.$store.dispatch('dashboard/deleteWebhook', item)
        },
    },
    computed: {
        projectList () {
            return this.entries.map(entry => {
                const name = entry.name.length > this.nameLimit
                    ? entry.name.slice(0, this.nameLimit) + '...'
                    : entry.name
                return Object.assign({}, entry, { name })
            })
        },
        isLoading() {
            return this.$store.state.dashboard.autocompleteLoading
        },
        snackbarText(){
            return this.$store.state.dashboard.snackbarText
        },
        tableLoading() {
            return this.$store.state.dashboard.tableLoading
        },
        items() {
            return this.$store.state.dashboard.webhooks
        },
        entries() {
            return this.$store.state.dashboard.projects
        },
        snackbar: {
            get() {
                return this.$store.state.dashboard.snackbar
            },
            set(value) {
                this.$store.commit('dashboard/snackbar', value)
            }
        }
    },
    watch: {
        dialog (val) {
            if (val) {
                this.$store.dispatch('dashboard/getAllProjects')
            }
            val || this.close()
        },

    },
    created () {
        this.initialize()
    },
}
</script>

<style>

</style>
